<!------------------------------------------------------------------------------
 File: CardBasic 
 Created by keni.
 with: IntelliJ IDEA
 Date: 09/05/2018
 Time: 16:06
------------------------------------------------------------------------------->
<template>
   <div class="card" :class="cls">
       <slot name="header">im the header</slot>
       <div data-ref="the body" class="card-body">
           <slot>

           </slot>
       </div>

   </div>

</template>

<script>
	export default {
		name: "card-with-header",
		components: {},
		props: {
			body_class:String,
			cls:String
        },
		created() {
		},
		destroyed() {
		},
		mounted() {

		},
		data() {
			return {}
		},
		methods: {},
		watch: {},
		computed: {}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/cards/CardWithHeader.vue?62def7f6